export const isBrowser = () => {
  return typeof window != 'undefined';
};
export const isTest = () => {
  return process.env.NODE_ENV === 'test';
};

export const isNumber = (val: any) => {
  // negative or positive
  return /^\d+$/.test(val);
};

//sadece
export const isAlphaWord = (word: string) => {
  // A case-insensitive regex to match alpha characters
  const ALPHA_REGEX = /^[a-zA-ZğüşöçıİĞÜŞÖÇ ]+$/i;

  // A function to test if a word only contains alpha characters
  return ALPHA_REGEX.test(word);
};

export const debug = (...args: any[]) => {
  if (process.env.NEXT_PUBLIC_APP_STAGE === 'dev') {
  }
}; //sadece test ortamında ve degug için çalışır

export const allReplace = (retStr?: string, obj?: any) => {
  for (var x in obj) {
    retStr = retStr?.replace(new RegExp(x, 'g'), obj[x]);
  }
  return retStr;
};

// 1970-10-10 to 10/10/1070
export const convertBirthdate = (date: string) => {
  const dateArray = date.split('-').reverse();
  return `${dateArray[0]}/${dateArray[1]}/${dateArray[2]}`;
};
